import {
  maxLength,
  minLength,
  object,
  pipe,
  string,
  type InferOutput
} from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

/**
 * 配送依頼履歴の検索フォームの値
 */
export const shipmentOrderHistoryFormValueSchema = object({
  /** 検索用の名前 */
  name: pipe(
    string(),
    minLength(1, VALIDATION_MESSAGES.MIN_LENGTH(1)),
    maxLength(100, VALIDATION_MESSAGES.MAX_LENGTH(100))
  )
})

/**
 * 配送依頼履歴の検索フォームの値
 */
export type ShipmentOrderHistoryFormValue = InferOutput<
  typeof shipmentOrderHistoryFormValueSchema
>

/**
 * 配送依頼履歴の検索フォームの初期値を作成
 */
export const createDefaultShipmentOrderHistoryFormValue = (
  name: string
): ShipmentOrderHistoryFormValue => ({
  name
})
